import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { Message } from '../../http/message';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
    selector: 'app-custom-snackbar',
    templateUrl: './custom-snackbar.component.html',
    styleUrls: ['./custom-snackbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class CustomSnackBarComponent {

    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public data: Message, public snackBarRef: MatSnackBarRef<CustomSnackBarComponent>) {
            this.snackBarRef._dismissAfter(data.Duration);
    }

    public dismiss() {
        this.snackBarRef.dismiss();
    }
}
